<template>
  <div class="rank-wrapper pa-2">
    <h3 class="body-2 font-weight-black">{{ value }}</h3>
    <h6 class="rank-label grey--text">{{ label }}</h6>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String
  }
}
</script>

<style lang="scss" scoped>
.rank-label {
  font-size: 11px;
  font-weight: normal;
}
</style>
